/**
 * Constantes pour les annulations côté frontend
 * CRÉÉ LE: 19 août 2025
 * Selon ASSISTANT_RULES.md - Règle 3 : Création de constantes si inexistantes
 * Aligné avec backend/constants/penaltyConstants.js
 */
import i18n from '../i18n';

// Types de pénalité d'annulation
export const CANCELLATION_PENALTY_TYPE = {
  NONE: 'none',
  PERCENTAGE: 'percentage', 
  REPUTATION: 'reputation'
};

// Conditions de paiement pour annulation
export const CANCELLATION_PAYMENT_CONDITION = {
  WITH_APP_PAYMENT: 'with_app_payment',
  WITHOUT_APP_PAYMENT: 'without_app_payment',
  ANY: 'any'
};

// Messages d'annulation — getters dynamiques pour respecter la langue active
export const CANCELLATION_MESSAGES = {
  get FREE_CANCELLATION() { return i18n.t('cancellation.freeCancellation'); },
  get PENALTY_PERCENTAGE() { return i18n.t('cancellation.penaltyPercentage'); },
  get REPUTATION_IMPACT() { return i18n.t('cancellation.reputationImpact'); },
  get TOO_CLOSE() { return i18n.t('cancellation.tooClose'); },
  get ALREADY_STARTED() { return i18n.t('cancellation.alreadyStarted'); },
  get STATUS_NOT_CANCELLABLE() { return i18n.t('cancellation.statusNotCancellable'); }
};

// Seuils temporels pour l'annulation (en heures)
export const CANCELLATION_TIME_THRESHOLDS = {
  FREE_CANCELLATION_HOURS: 12,
  MINIMUM_CANCELLATION_HOURS: 1,
  PENALTY_PERCENTAGE: 20
};

// Constantes de conversion temporelle
export const TIME_CONSTANTS = {
  MILLISECONDS_TO_HOURS: 1000 * 60 * 60
};

// Rôles d'annulation (aligné avec backend)
export const CANCELLED_BY_FRONTEND = {
  RENTER: 'renter',
  OWNER: 'owner'
};

// Constantes pour les caches
export const CACHE_KEYS = {
  RENTER_RESERVATIONS: 'renter_reservations',
  OWNER_RESERVATIONS: 'owner_reservations'
};

export default {
  CANCELLATION_PENALTY_TYPE,
  CANCELLATION_PAYMENT_CONDITION,
  CANCELLATION_MESSAGES,
  CANCELLATION_TIME_THRESHOLDS,
  TIME_CONSTANTS,
  CANCELLED_BY_FRONTEND,
  CACHE_KEYS
};
